var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      ref: "modal",
      staticClass: "modal-wrap",
    },
    [
      _c("div", {
        staticClass: "modal-cover",
        on: { click: _vm.handleCoverClick },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          class: { auto_scale: _vm.shouldNotAutoScale ? false : true },
        },
        [
          _c(
            "div",
            { staticClass: "modal-content" },
            [_vm._t("modal-content")],
            2
          ),
          _vm._v(" "),
          _vm.showClose
            ? _c("div", {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    return _vm.handleCloseBtnClick("closeBtn")
                  },
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showBack,
            expression: "showBack",
          },
        ],
        staticClass: "back",
        on: { click: _vm.handleBackClick },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }